var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { TagsSearchModalContainer, TagsSearchModalWrapper, CardsWrapper, NoProjectWrapper } from './styles';
import { API } from '@brg/api';
import queryString from 'query-string';
import { CountryViewCard } from '../../cards/CountryViewCard';
import { useProfile } from '@brg/auth';
import LangContext from '../../../contexts/Language/LangContext';
import { debounceEvent, useGetUserCollectionCards } from './CardSelectModal';
import { Colors, FlexBox, useIsMobile } from '@brg/ui';
import { ModalButton, ModalText, ProductTagsSearchTitle } from '../ProductsSelectModal/styles';
import { ProjectSearchBarSorting } from '../../projectsSearchBar/components/projectSearchBarSorting';
import { SearchInputComponent } from '../SendProjectModal/SearchInput/SearchInputComponent';
import { BookCheckBox } from '../../desktopApp/modules/inputs/BookCheckBox';
import { Pagination } from "../../pagination";
import Masonry from "react-masonry-css";
import useCommonProps from '../../../hooks/useCommonProps';
var CardSelectManyModal = function (_a) {
    var _b, _c, _d, _e;
    var onSubmit = _a.onSubmit, _f = _a.cardIds, cardIds = _f === void 0 ? [] : _f, isPay = _a.isPay, bookId = _a.bookId;
    var _g = useState(''), search = _g[0], setSearch = _g[1];
    var _h = useState(false), isForPay = _h[0], setIsForPay = _h[1];
    var profile = useProfile();
    // @ts-ignore
    var t = useContext(LangContext).t;
    var _j = useState(cardIds), selectedCards = _j[0], setSelectedCards = _j[1];
    var _k = useState(1), sorting = _k[0], setSorting = _k[1];
    var _l = useState('all'), activeTab = _l[0], setActiveTab = _l[1];
    var _m = useState(1), currentPage = _m[0], setPage = _m[1];
    var scrollRef = useRef(null);
    var isMobile = useIsMobile();
    var scrollTop = function () {
        var _a;
        if (!scrollRef.current)
            return;
        (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    };
    var authorId = useCommonProps().authorId;
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify(__assign({ cardOnlyImage: true, status: [2], search: search, isHeaderIgnored: true, isLite: 'true', limit: 50, page: currentPage, sort: sorting }, (activeTab === 'all' ? { userIds: profile ? [authorId] : [] } : { cardIds: !!(selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) ? selectedCards : null })));
    }, [search, sorting, currentPage, activeTab, selectedCards]);
    var data = useGetUserCollectionCards((profile === null || profile === void 0 ? void 0 : profile.accountId) ? cardsQueryString : undefined).data;
    // @ts-ignore
    var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, 'en');
    useEffect(function () {
        setIsForPay(isPay);
    }, [isPay]);
    var onInputText = function (e) {
        var text = e.trim();
        setSearch(text);
    };
    var onClick = useCallback(function (cardId) {
        if (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.includes(cardId)) {
            setSelectedCards(selectedCards.filter(function (item) { return item !== cardId; }));
            return;
        }
        setSelectedCards(__spreadArray(__spreadArray([], selectedCards, true), [cardId], false));
    }, [selectedCards]);
    var handleAttachClick = function () {
        onSubmit(selectedCards, isForPay);
    };
    var onChangeTab = function (tabName) {
        setPage(1);
        setActiveTab(tabName);
    };
    return (React.createElement(TagsSearchModalWrapper, { ref: scrollRef, autoScroll: true, isWhite: true },
        React.createElement(TagsSearchModalContainer, null,
            React.createElement(FlexBox, { justify: 'space-between', align: 'center', offsetBottom: 48 },
                React.createElement(ProductTagsSearchTitle, null, t('modal.select_card_modal.select_cards')),
                React.createElement(FlexBox, { gx: 32, align: 'center' },
                    bookId && React.createElement(BookCheckBox, { isModal: true, value: isForPay, onChange: setIsForPay }),
                    React.createElement(ModalButton, { onClick: handleAttachClick, fill: Colors.galBlack100 }, t('competition.send')))),
            React.createElement(FlexBox, { justify: 'space-between', offsetBottom: 24 },
                React.createElement(FlexBox, { align: 'center', gx: 24 },
                    React.createElement(ModalText, { style: { cursor: 'pointer' }, onClick: function () { return onChangeTab('all'); }, color: activeTab === 'all' ? Colors.galBlack100 : Colors.galBlack47 }, t('modal.select_card_modal.cards')),
                    React.createElement(ModalText, { style: { cursor: 'pointer' }, onClick: function () { return onChangeTab('selected'); }, color: activeTab === 'selected' ? Colors.galBlack100 : Colors.galBlack47 }, "".concat(t('modal.select_card_modal.selected_cards'), ": ").concat(selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length)))),
            React.createElement(FlexBox, { justify: 'space-between', gx: 24, offsetBottom: 24 },
                React.createElement(SearchInputComponent, { setSearchText: debounceEvent(onInputText, 500), placeholder: t('modal.select_card_modal.search_card') }),
                React.createElement(FlexBox, { style: { minWidth: '270px' }, justify: 'flex-end' },
                    React.createElement(ProjectSearchBarSorting, { selectedSorting: sorting, onSortingChange: setSorting, sortingMethods: [1, 2] }))),
            ((cards === null || cards === void 0 ? void 0 : cards.length) > 0 && !(activeTab === "selected" && (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) === 0)) ? (React.createElement(React.Fragment, null,
                React.createElement(CardsWrapper, null,
                    React.createElement(Masonry, { breakpointCols: isMobile ? 2 : 4, className: "main-page-masonry-grid", columnClassName: "main-page-masonry-grid_column" }, !!data &&
                        (
                        /* @ts-ignore */
                        cards === null || cards === void 0 ? void 0 : cards.map(function (museumCard) { return (React.createElement(React.Fragment, null,
                            React.createElement(CountryViewCard, { key: museumCard.cardId, cardId: museumCard.cardId, museumCard: museumCard, onClickHandler: onClick, borderless: true, selectable: true, nohover: true, selected: selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.includes(museumCard.cardId) }))); })))),
                React.createElement(Pagination
                // @ts-ignore
                , { 
                    // @ts-ignore
                    pages: (_c = (_b = data === null || data === void 0 ? void 0 : data.paging) === null || _b === void 0 ? void 0 : _b.pages) !== null && _c !== void 0 ? _c : 0, page: Number(currentPage), onPageChange: function (page) {
                        // @ts-ignore
                        setPage(page);
                        scrollTop();
                    }, 
                    // @ts-ignore
                    isCanLoadMore: currentPage < ((_e = (_d = data === null || data === void 0 ? void 0 : data.paging) === null || _d === void 0 ? void 0 : _d.pages) !== null && _e !== void 0 ? _e : 0) }))) : (React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :(")))));
};
export default CardSelectManyModal;
//# sourceMappingURL=CardSelectManyModal.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { TagsSearchModalContainer, TagsSearchModalWrapper, CardsWrapper, NoProjectWrapper } from './styles';
import { API } from '@brg/api';
import queryString from 'query-string';
import { CountryViewCard } from '../../cards/CountryViewCard';
import { useProfile } from '@brg/auth';
import LangContext from '../../../contexts/Language/LangContext';
import { debounceEvent, useGetUserCollectionCards } from './CardSelectModal';
import { Colors, FlexBox, useIsMobile } from '@brg/ui';
import { ModalButton, ModalText, ProductTagsSearchTitle } from '../ProductsSelectModal/styles';
import { ProjectSearchBarSorting } from '../../projectsSearchBar/components/projectSearchBarSorting';
import { SearchInputComponent } from '../SendProjectModal/SearchInput/SearchInputComponent';
import { BookCheckBox } from '../../desktopApp/modules/inputs/BookCheckBox';
import { Pagination } from "../../pagination";
import Masonry from "react-masonry-css";
import useCommonProps from '../../../hooks/useCommonProps';
var CardSelectManyModal = function (_a) {
    var _b, _c, _d, _e;
    var onSubmit = _a.onSubmit, _f = _a.cardIds, cardIds = _f === void 0 ? [] : _f, isPay = _a.isPay, bookId = _a.bookId;
    var _g = useState(''), search = _g[0], setSearch = _g[1];
    var _h = useState(false), isForPay = _h[0], setIsForPay = _h[1];
    var profile = useProfile();
    // @ts-ignore
    var t = useContext(LangContext).t;
    var _j = useState(cardIds), selectedCards = _j[0], setSelectedCards = _j[1];
    var _k = useState(1), sorting = _k[0], setSorting = _k[1];
    var _l = useState('all'), activeTab = _l[0], setActiveTab = _l[1];
    var _m = useState(1), currentPage = _m[0], setPage = _m[1];
    var scrollRef = useRef(null);
    var isMobile = useIsMobile();
    var scrollTop = function () {
        var _a;
        if (!scrollRef.current)
            return;
        (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    };
    var authorId = useCommonProps().authorId;
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify(__assign({ cardOnlyImage: true, status: [2], search: search, isHeaderIgnored: true, isLite: 'true', limit: 50, page: currentPage, sort: sorting }, (activeTab === 'all' ? { userIds: profile ? [authorId] : [] } : { cardIds: !!(selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) ? selectedCards : null })));
    }, [search, sorting, currentPage, activeTab, selectedCards]);
    var data = useGetUserCollectionCards((profile === null || profile === void 0 ? void 0 : profile.accountId) ? cardsQueryString : undefined).data;
    // @ts-ignore
    var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, 'en');
    useEffect(function () {
        setIsForPay(isPay);
    }, [isPay]);
    var onInputText = function (e) {
        var text = e.trim();
        setSearch(text);
    };
    var onClick = useCallback(function (cardId) {
        if (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.includes(cardId)) {
            setSelectedCards(selectedCards.filter(function (item) { return item !== cardId; }));
            return;
        }
        setSelectedCards(__spreadArray(__spreadArray([], selectedCards, true), [cardId], false));
    }, [selectedCards]);
    var handleAttachClick = function () {
        onSubmit(selectedCards, isForPay);
    };
    var onChangeTab = function (tabName) {
        setPage(1);
        setActiveTab(tabName);
    };
    return (React.createElement(TagsSearchModalWrapper, { ref: scrollRef, autoScroll: true, isWhite: true },
        React.createElement(TagsSearchModalContainer, null,
            React.createElement(FlexBox, { justify: 'space-between', align: 'center', offsetBottom: 48 },
                React.createElement(ProductTagsSearchTitle, null, t('modal.select_card_modal.select_cards')),
                React.createElement(FlexBox, { gx: 32, align: 'center' },
                    bookId && React.createElement(BookCheckBox, { isModal: true, value: isForPay, onChange: setIsForPay }),
                    React.createElement(ModalButton, { onClick: handleAttachClick, fill: Colors.galBlack100 }, t('competition.send')))),
            React.createElement(FlexBox, { justify: 'space-between', offsetBottom: 24 },
                React.createElement(FlexBox, { align: 'center', gx: 24 },
                    React.createElement(ModalText, { style: { cursor: 'pointer' }, onClick: function () { return onChangeTab('all'); }, color: activeTab === 'all' ? Colors.galBlack100 : Colors.galBlack47 }, t('modal.select_card_modal.cards')),
                    React.createElement(ModalText, { style: { cursor: 'pointer' }, onClick: function () { return onChangeTab('selected'); }, color: activeTab === 'selected' ? Colors.galBlack100 : Colors.galBlack47 }, "".concat(t('modal.select_card_modal.selected_cards'), ": ").concat(selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length)))),
            React.createElement(FlexBox, { justify: 'space-between', gx: 24, offsetBottom: 24 },
                React.createElement(SearchInputComponent, { setSearchText: debounceEvent(onInputText, 500), placeholder: t('modal.select_card_modal.search_card') }),
                React.createElement(FlexBox, { style: { minWidth: '270px' }, justify: 'flex-end' },
                    React.createElement(ProjectSearchBarSorting, { selectedSorting: sorting, onSortingChange: setSorting, sortingMethods: [1, 2] }))),
            ((cards === null || cards === void 0 ? void 0 : cards.length) > 0 && !(activeTab === "selected" && (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) === 0)) ? (React.createElement(React.Fragment, null,
                React.createElement(CardsWrapper, null,
                    React.createElement(Masonry, { breakpointCols: isMobile ? 2 : 4, className: "main-page-masonry-grid", columnClassName: "main-page-masonry-grid_column" }, !!data &&
                        (
                        /* @ts-ignore */
                        cards === null || cards === void 0 ? void 0 : cards.map(function (museumCard) { return (React.createElement(React.Fragment, null,
                            React.createElement(CountryViewCard, { key: museumCard.cardId, cardId: museumCard.cardId, museumCard: museumCard, onClickHandler: onClick, borderless: true, selectable: true, nohover: true, selected: selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.includes(museumCard.cardId) }))); })))),
                React.createElement(Pagination
                // @ts-ignore
                , { 
                    // @ts-ignore
                    pages: (_c = (_b = data === null || data === void 0 ? void 0 : data.paging) === null || _b === void 0 ? void 0 : _b.pages) !== null && _c !== void 0 ? _c : 0, page: Number(currentPage), onPageChange: function (page) {
                        // @ts-ignore
                        setPage(page);
                        scrollTop();
                    }, 
                    // @ts-ignore
                    isCanLoadMore: currentPage < ((_e = (_d = data === null || data === void 0 ? void 0 : data.paging) === null || _d === void 0 ? void 0 : _d.pages) !== null && _e !== void 0 ? _e : 0) }))) : (React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :(")))));
};
export default CardSelectManyModal;
//# sourceMappingURL=CardSelectManyModal.js.map